module.exports = __webpack_public_path__ + "app/modals/event.view.html";